import script from "./AddAttendee.vue?vue&type=script&setup=true&lang=js"
export * from "./AddAttendee.vue?vue&type=script&setup=true&lang=js"

import "./AddAttendee.vue?vue&type=style&index=0&id=1a492385&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a492385"]])

export default __exports__